import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { post } from "../../lib/request"
import {
  dashboardPlatformKeyFromDescription,
  isInstagramGraphDescription,
} from "../../lib/utils/socialNetworkCatalog"

/**
 * payload = {
 *   channel: 'facebook' | 'instagram' | 'twitter',
 *   messageId: number,
 *   text: string,
 *   files?: FileList
 * }
 */
export const sendReplyMessage = createAsyncThunk(
  "reply/send",
  async ({ channel, messageId, text, files }, { rejectWithValue }) => {
    try {
      const formData = new FormData()
      // formData.append("commentText", text)

      if (files && files.length) {
        Array.from(files).forEach((file) => {
          formData.append("attachment_file", file)
        })
      }

      let endpoint = ""
      const ch = (channel || "").toLowerCase()
      const dashboardKey = dashboardPlatformKeyFromDescription(ch)

      if (ch === "facebook" || dashboardKey === "facebook") {
        endpoint = `/facebook/messages/${messageId}/reply?commentText=${encodeURIComponent(text)}`
      } else if (isInstagramGraphDescription(ch) || ch === "instagram") {
        endpoint = `/instagram/messages/${messageId}/reply?commentText=${encodeURIComponent(text)}`
      } else if (ch === "twitter" || ch === "x" || dashboardKey === "twitter") {
        endpoint = `/twitter/messages/${messageId}/reply?commentText=${encodeURIComponent(text)}`
      }

      if (!endpoint) {
        return rejectWithValue(`Unsupported channel: ${channel}`)
      }

      const data = await post(endpoint, formData)
      if (data && typeof data === "object" && data.success === false) {
        const msg =
          (typeof data.message === "string" && data.message.trim()) ||
          (typeof data.code === "string" && data.code) ||
          "Reply failed"
        return rejectWithValue(msg)
      }
      return data
    } catch (err) {
      return rejectWithValue(err?.message || String(err || "Request failed"))
    }
  }
)

const replyMessageSlice = createSlice({
  name: "replyMessage",
  initialState: {
    loading: false,
    error: null,
  },
  reducers: {
    resetReplyState: (state) => {
      state.loading = false
      state.error = null
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(sendReplyMessage.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(sendReplyMessage.fulfilled, (state) => {
        state.loading = false
      })
      .addCase(sendReplyMessage.rejected, (state, action) => {
        state.loading = false
        state.error = action.payload
      })
  },
})

export const { resetReplyState } = replyMessageSlice.actions
export default replyMessageSlice.reducer
